import { Form } from '@.hooks';

export const toState = <T extends object>(data: Partial<T>) =>
    Object.fromEntries(Object.entries(data).map(([key, value]) => [key, { value, errors: undefined }])) as Form<T>;
